<template>
    <div class="container-fluid">
        <p class="welcome"></p>
         <div class="col-lg-12 col-sm-12 pt-3 dashboard-page">             
              <div class="col-lg-6 col-sm-6 pt-3">
                <div @click="go_back()" style="cursor:pointer" class="font-weight-normal back-button mb-4"> 
                    Back
                </div>
                <div class="dashboard-inner-new" v-if="!isShowUserSubscription">
                    <div class="panel-title mt-4">
                        <!-- <p class="ptitle">{{service}}</p> -->
                    </div>
                    <div class="airtime-data">
                        <button class="airtime1 ml-2" ><i class="fas fa-satellite-dish icon"></i> TV Subscriptions</button>
                    </div>

                    <div class="mobile-operator">
                        <label for="" class="payment-label">Select TV Subscription</label>
                        <div class="operator-icons">
                            <button 
                                class="op-icons" 
                                type="button"
                                :class="{ 'selected': network === '5' }" 
                                @click="select_network('5')">
                                <img src="../assets/dstv.svg" alt="DSTV">
                            </button>
                            <button 
                                class="op-icons" 
                                type="button"
                                :class="{ 'selected': network === '4' }" 
                                @click="select_network('4')">
                                <img src="../assets/gotv.svg" alt="GOTV">
                            </button>
                            <button 
                                class="op-icons" 
                                type="button"
                                :class="{ 'selected': network === '6' }" 
                                @click="select_network('6')">
                                <img src="../assets/startimes.jpg" alt="Startimes">
                            </button>
                        </div>
                        
                    </div>
                     <div class="payment-method">
                        <label for="" class="payment-label">Smart Card Number</label>
                        <input type="text" name="" id="" class="payment-input" placeholder="E.g. 2233561782" v-model="smart_card_number" inputmode="numeric" pattern="[0-9]*" @keypress="onlyNumber($event)">
                    </div>                  
                    <div class="payment-method" v-if="is_loading_tv">
                       <center><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> loading packages... </center> 
                    </div>
                    <div class="payment-method" v-if="is_plan_available">
                            <v-autocomplete
                            required
                            v-model="cabletv_package"
                            label="Select Packages *"
                            :items="dataList"
                            variant="outlined"
                        ></v-autocomplete>
                    </div>
                   
                    <div class="btn-panel">
                        <button id="submit4" class="btn-continue"  @click="cabletv_purchase()" v-if="!loading5">Continue</button>
                        <button class="btn-continue" type="button" disabled v-if="loading5">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                        <button class="btn-cancel" @click="go_back()">Cancel</button>
                    </div>
                    
                </div>
                <div class="dashboard-inner-new" v-if="isShowUserSubscription">
                    <div class="panel-title mt-4">
                        <!-- <p class="ptitle">{{service}}</p> -->
                    </div>
                    <div class="airtime-data">
                        <button class="airtime1 ml-2" >Subscription Details</button>
                    </div>
                    <div class="payment-method">
                        <label for="" class="payment-label">Customer name</label>
                        <input type="text" name="" id="" class="payment-input a-text"  v-model="subscription_details.Customer_Name" disabled>
                    </div>
                    <!-- <div class="payment-method">
                        <label for="" class="payment-label">Customer number</label>
                        <input type="text" name="" id="" class="payment-input"  v-model="subscription_details.Customer_Number" disabled>
                    </div> -->
                    <div class="payment-method">
                        <label for="" class="payment-label">Customer type</label>
                        <input type="text" name="" id="" class="payment-input a-text"  v-model="subscription_details.Customer_Type" disabled>
                    </div>
                    <!-- <div class="payment-method">
                        <label for="" class="payment-label">Current bouquet</label>
                        <input type="text" name="" id="" class="payment-input a-text" v-model="subscription_details.Current_Bouquet" disabled>
                    </div> -->
                    <div class="payment-method">
                        <label for="" class="payment-label">Renewal amount</label>
                        <input type="text" name="" id="" class="payment-input a-text" v-model="subscription_details.Renewal_Amount" disabled>
                    </div>
                    <div class="payment-method">
                        <label for="" class="payment-label">Due Date</label>
                        <input type="text" name="" id="" class="payment-input a-text" v-model="subscription_details.Due_Date" disabled>
                    </div>
                    
                    <div class="btn-panel">
                        <button id="submit4" class="btn-continue"  @click="subscribe_operation()">Subscribe</button>
                        <button class="btn-cancel" @click="go_back1()">Back</button>
                    </div>
                    
                </div>
              </div>
         </div>
         <div v-if="isConfirm">
            <transition name="modal">
                <div class="vcard-modal-mask">
                    <div class="modal-wrapper col-md-3" style="margin:auto">
                        <div class="row">
                            <div class="col-md-1">
                            </div>
                            <div class="col-md-10">
                                <div class="row d-flex flex-column align-items-center">
                                    <p class="text-black text-uppercase text-center mt-6">Enter your transaction pin</p>
                                    <div class="inputs1"> 
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off"  v-model="verify_code1" required @input="moveToNext(1)" ref="input1" name="input1" id="input1" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code2" required @input="moveToNext(2)" ref="input2" name="input2" id="input2" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1" class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code3" required @input="moveToNext(3)" ref="input3" name="input3" id="input3" @keypress="onlyNumber($event)">
                                        <input type="password" maxlength="1"  class="form-control inputs-field1" inputmode="numeric" pattern="[0-9]*" autocomplete="off" v-model="verify_code4" required @input="moveToNext(4)" ref="input4" name="input4" id="input4" @keypress="onlyNumber($event)">
                                    </div>
                                
                                    <div class="btn-inputs">
                                        <button id="submit4" class="btn btn-primary btn-block mt-4 mb-4"  @click="confirm_wallet_purchase()" v-if="!loading4">Confirm</button>
                                        <button class="btn btn-primary btn-block mt-4 mb-4" type="button" disabled v-if="loading4">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        </button>
                                        <button class="btn btn-block" @click="isConfirm = false">X</button>
                                        <br>
                                    </div>     
                                </div>
                            </div>
                            <div class="col-md-1">
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
         </div>
          <p>&nbsp;</p>
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
  </template>
  <script>
  import swal from 'sweetalert2';
  import PageLoader from '../components/PageLoader.vue'
  export default {
    
    name: "AirtimeDataPage",
    components: {
      PageLoader
    },
  
    data(){
      return {
          search: '',
          loading: false,
          isLoading: false,
          loading4: false,
          user_id: '',
          firstname: '',
          lastname: '',
          bank_name:'',
          account_name:'',
          account_number: '',
          funding_amount: '',
          error: '',
          payment_reference: '',
          fullname: '',
          cpayment_method: 'regular-payment',
          utility_option: '',  
          service: '', 
          network: '',
          payment_method: '',
          smart_card_number: '',
          airtime_amount: '',   
          walletBal: '',
          quick_amount: '',
          dataList: [],
          is_plan_available: false,
          cabletv_package: '',
          plan_name: '',
          networks: {
            5: 'DSTV',
            4: 'GOTV',
            6: 'Startimes'
          },
          paymentRef: '',
          clientRef: '',
          order_reference: '',
          selectedAmount: 0,
          selectedPlanId: '',
          selectedPlanName: '',
          paymentModeLoading: false,
          isPaymentModeModal: false,
          verify_code: '',
          verify_code1: '',
          verify_code2: '',
          verify_code3: '',
          verify_code4: '',
          isConfirm: false,
          is_loading_tv: false,
          isShowUserSubscription: false,
          subscription_details: [],
          loading5: false,
          
        };
    },
  
    beforeMount(){
      this.user_id = localStorage.getItem("userid");
    },
  
    mounted(){
        
        this.firstname = localStorage.getItem("firstname");
        this.lastname = localStorage.getItem("lastname");
        this.phone_number = localStorage.getItem("phone");
        this.email_address = localStorage.getItem("email");
        this.user_id = localStorage.getItem("userid");
        this.fullname = this.firstname +'_'+ this.lastname 
        this.utility_option = 'cabletv'
        // this.utility_option = this.$route.params.service
        // if(this.utility_option == 'airtime'){
        //     this.service = 'Buy Airtime'
        // }
        // else if(this.utility_option == 'data'){
        //     this.service = 'Buy Data'
        // }
       // this.get_wallet_balance(this.user_id)
       // this.fetch_user_pin()
    },
  
    created(){
          
    },
  
    computed: {
    
    },
  
    methods: {
        onlyNumber(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    },
        async fetch_user_pin(){
            try {
                const response = await this.$http.post('/fetch-pin', {
                    user_id: this.user_id
                })         
                this.user_pin = response.data.data

            } catch (err) {
                console.log(err);
            }
        },

        moveToNext(index) {
            const verifyCode = this[`verify_code${index}`];
            if (verifyCode.length === 1) {
                const nextIndex = index + 1;
                if (nextIndex <= 4) {
                    this.$refs[`input${nextIndex}`].focus();
                }
            }
        },
        handlePaste(event) {
        event.preventDefault(); // Prevent the default paste behavior
        const pasteData = event.clipboardData.getData('text');
        if (pasteData.length === 4) {
            this.verify_code1 = pasteData[0];
            this.verify_code2 = pasteData[1];
            this.verify_code3 = pasteData[2];
            this.verify_code4 = pasteData[3];

            // Move focus to the last input field
            this.$nextTick(() => {
            this.$refs.input4.focus();
            });
            }
        },
        formatAmount(amount) {
            const value = Number(amount || 0);
            return value.toLocaleString('en-NG', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        showWarning(message) {
            swal.fire({
                icon: 'warning',
                title: 'Warning',
                width: 450,
                height: 5,
                text: message,
            });
        },
        normalizeAmount(value) {
            const numeric = Number(String(value || 0).replace(/[^0-9.]/g, ''));
            return Number.isFinite(numeric) ? numeric : 0;
        },
        resolveSelectedCabletvPackage() {
            const selected = this.cabletv_package;

            if (!selected) {
                return null;
            }

            if (typeof selected === 'object') {
                return {
                    planCode: selected.value || selected.planCode || selected.planId || selected.id || '',
                    planName: selected.planName || selected.text || selected.label || '',
                    amount: selected.planPrice || selected.amount || '',
                };
            }

            const matched = this.dataList.find((item) => {
                return item.value === selected || item.planCode === selected || item.planId === selected || item.text === selected;
            });

            if (matched) {
                return {
                    planCode: matched.value || matched.planCode || selected,
                    planName: matched.planName || matched.text || selected,
                    amount: matched.planPrice || matched.amount || '',
                };
            }

            const parts = String(selected).split('-');

            return {
                planCode: parts[0] ? parts[0].trim() : String(selected),
                planName: parts[0] ? parts[0].trim() : String(selected),
                amount: parts[1] ? parts[1].trim() : '',
            };
        },
        async cabletv_purchase() {
            return this.data_purchase();
        },
        async data_purchase() {
            try {
                localStorage.removeItem('paymentData');
                localStorage.removeItem('dataWalletPurchase');

                if (!this.network) {
                    this.showWarning('Please select service provider');
                    return;
                }
                if (!this.smart_card_number) {
                    this.showWarning('Please enter smart card number');
                    return;
                }
                if (!this.cabletv_package) {
                    this.showWarning('Please select your package');
                    return;
                }

                const selectedPackage = this.resolveSelectedCabletvPackage();

                if (!selectedPackage || !selectedPackage.planCode) {
                    this.showWarning('Please select a valid package');
                    return;
                }

                const amount = this.normalizeAmount(selectedPackage.amount || selectedPackage.planPrice || 0);

                if (!amount) {
                    this.showWarning('Unable to determine the package amount');
                    return;
                }

                this.loading5 = true;

                let orderReference = `CTV-${Date.now().toString().slice(-8)}`;

                try {
                    const { data } = await this.$http.post('/etransact/bill-payment-query', {
                        clientRef: this.clientRef || orderReference,
                        billQueryRef: this.paymentRef || orderReference,
                        firstname: this.firstname,
                        lastname: this.lastname,
                        email_address: this.email_address,
                        phone: this.smart_card_number,
                        amount,
                        userid: this.user_id,
                        service_id: this.network,
                        payment_method: 'quick-payment',
                    });

                    if (data && data.success) {
                        orderReference = data.order_reference || orderReference;
                    } else if (data && data.message) {
                        console.log(data.message);
                    }
                } catch (queryErr) {
                    console.log(queryErr);
                }

                const payload = {
                    utility: 'cabletv',
                    payment_amount: amount,
                    amount,
                    company_package: this.network,
                    productId: selectedPackage.planCode,
                    company_name: this.plan_name || this.networks[Number(this.network)] || 'Cable TV',
                    plan_name: selectedPackage.planName || this.plan_name || 'Cable TV',
                    meter_number: this.smart_card_number,
                    meter_type: this.network,
                    network: this.network,
                    order_reference: orderReference,
                    service_fee: 0,
                    customer_name: this.smart_card_number,
                    customer_id: this.smart_card_number,
                    createdAt: Date.now()
                };

                localStorage.setItem('dataWalletPurchase', JSON.stringify(payload));
                this.selectedAmount = amount;
                this.selectedPlanId = selectedPackage.planCode;
                this.selectedPlanName = payload.plan_name;
                this.order_reference = orderReference;
                this.loading5 = false;
                this.$router.push('/data-wallet-purchase');
            } catch (err) {
                console.log(err);
                this.loading5 = false;
                this.showWarning('Something went wrong. Please try again.');
            }
        },
       async select_network(network){
                    try{

                        if (!this.smart_card_number) {
                            confirm("Please enter your smart card number")
                            return;
                        }

                        this.dataList = []
                        this.is_loading_tv = true
                        this.network = network
                        const response = await this.$http.post('/etransact/cabletv-biller-query', {
                            service_id: this.network,
                            customerId: this.smart_card_number
                        });

                        console.log(response.data.data.plans)
                        this.is_loading_tv = false
                        if (response.data.status) {
                            this.plan_name = this.networks && this.networks[Number(network)] ? this.networks[Number(network)] : this.network
                            this.paymentRef = response.data.data.paymentRef || ''
                            this.clientRef = response.data.data.clientRef || ''

                            response.data.data.plans.forEach(el => {
                                this.dataList.push({
                                    text: el.planName + ' - ' + el.planPrice,
                                    value: el.planCode,
                                    planName: el.planName,
                                    planPrice: el.planPrice
                                })
                            });  
                            this.is_plan_available = true
                            return;  
                        }
                        else{
                            swal.fire({
                                icon: 'error',
                                title: 'Error',
                                width: 450,
                                height: 5,
                                text: response.data.data.errorMessage,
                            })
                            return;
                        }
                        
                        
                }catch (err) {
                     console.log(err);
                    swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    height: 5,
                    text: err.response ? err.response.data.message : err.message,
                })
                }            
       },

        quick_option(option){
            this.airtime_amount = option
            this.quick_amount = option
        },
        async get_wallet_balance(){
                try{
                        const response = await this.$http.post('/fetch-wallet-balance', {
                            userid: this.user_id,
                        });
                        this.walletBal = response.data.balance
                        return;              
                        
                }catch (err) {
                    console.log(err);
                }
       },

        validateInput(){
            const value = this.funding_amount;
            if (value < 0) {
            this.error = 'Value must be non-negative';
            this.funding_amount = ''
            return
            } else if (!Number.isInteger(Number(value))) {
            this.error = 'Value must be an integer';
            this.funding_amount = ''
            return
            } else {
            this.error = '';
            }
        },


        subscribe_operation(){
            if (!this.network) {
                swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    width: 450,
                    height: 5,
                    text: 'Please select service provider',
                })
                return;
            }
            if (!this.smart_card_number) {
                swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    width: 450,
                    height: 5,
                    text: 'Please enter smart card number',
                })
                return;
            }
            if (!this.cabletv_package) {
                swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    width: 450,
                    height: 5,
                    text: 'Please select your package',
                })
                return;
            }

            this.isConfirm = true
        },

        async validate_wallet_pin(pin) {
            const response = await this.$http.post('/validate-pin', {
                phone_number: this.phone_number,
                pin: pin,
            })

            if (!response.data.success) {
                swal.fire({
                    icon: 'warning',
                    title: 'PIN validation failed',
                    width: 450,
                    height: 5,
                    text: response.data.message || 'Invalid transaction pin',
                })
                return false
            }

            return true
        },

        async confirm_wallet_purchase() {
            try {              
                
                    // if (!this.payment_method) {
                    // swal.fire({
                    //     icon: 'warning',
                    //     title: 'Warning',
                    //     width: 450,
                    //     height: 5,
                    //     text: 'Please select payment method',
                    // })
                    // return;
                    // }
                if (!this.network) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: 'Please select service provider',
                    })
                    return;
                }
                if (!this.smart_card_number) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: 'Please enter smart card number',
                    })
                    return;
                }
                if (!this.cabletv_package) {
                swal.fire({
                    icon: 'warning',
                    title: 'Warning',
                    width: 450,
                    height: 5,
                    text: 'Please select your package',
                })
                return;
                }
                const verify_code = this.verify_code1 + '' + this.verify_code2 + '' + this.verify_code3 + '' + this.verify_code4

                if (verify_code.length !== 4) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: 'Please enter your 4-digit transaction pin',
                    })
                    return;
                }

                this.loading4 = true

                const isValidPin = await this.validate_wallet_pin(verify_code)
                if (!isValidPin) {
                    this.loading4 = false
                    return;
                }

                const amount = this.subscription_details && this.subscription_details.Renewal_Amount
                    ? this.subscription_details.Renewal_Amount
                    : 0

                const response = await this.$http.post('/etransact/cabletv-wallet-purchase', {
                    smart_card_number: this.smart_card_number,
                    plan: this.cabletv_package,
                    network: this.network,
                    userid: this.user_id,
                    amount: amount,
                    email: this.email_address,
                    phone_number: this.phone_number,
                })
                this.loading4 = false

                if (!response.data.success) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
                    return;
                }

                this.isConfirm = false
                this.verify_code1 = ''
                this.verify_code2 = ''
                this.verify_code3 = ''
                this.verify_code4 = ''

                swal.fire({
                    icon: 'success',
                    title: 'Success',
                    width: 450,
                    height: 5,
                    text: response.data.message || 'Cable TV wallet purchase successful',
                })
                this.$router.push('/home')
                return;
                      
                    //}
                    // else{
                    //     this.loading4 = true

                    //     const verify_code = this.verify_code1+''+this.verify_code2+''+this.verify_code3+''+this.verify_code4

                    //     const response = await this.$http.post('/purchase-tv-package', {
                    //         smart_card_number: this.smart_card_number,
                    //         cabletv_package: this.cabletv_package,
                    //         network: this.network,
                    //         userid: this.user_id,
                    //         verify_code: verify_code,
                    //         payment_method: this.payment_method,
                    //     })
                    //     this.loading4 = false

                    //     if (!response.data.success) {
                    //         swal.fire({
                    //             icon: 'warning',
                    //             title: 'Warning',
                    //             width: 450,
                    //             height: 5,
                    //             text: response.data.message,
                    //         })
                    //         return;
                    //     }
                    //     swal.fire({
                    //             icon: 'success',
                    //             title: 'Success',
                    //             width: 450,
                    //             height: 5,
                    //             text: response.data.message,
                    //         })
                    //     this.$router.push('/home')
                    //     return;
                    // }
                             
            } catch (err) {
                this.loading4 = false
                console.log(err);
                swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    height: 5,
                    text: err.response ? err.response.data.message : err.message,
                })
            }
        },

        async bank_transfer(){
            try {
                    if (!this.funding_amount) {
                    swal.fire({
                        icon: 'warning',
                        title: 'Warning',
                        width: 450,
                        height: 5,
                        text: 'Please enter amount to fund',
                    })
                    return;
                    }

                    this.loading = true
                    this.payment_reference = Date.now() % 100000
                    const full_name = this.firstname
                    const ref = full_name + '_' + this.payment_reference

                    if (this.cpayment_method == 'regular-payment') {

                    this.loading = false
                    this.$router.push('/bank-transfer/'+ref+'/'+this.funding_amount)
                    }
                    else if (this.cpayment_method == 'quick-payment') {
                    swal.fire({
                        icon: 'info',
                        title: 'Quick Payment!',
                        width: 450,
                        height: 5,
                        text: 'Not available at the moment',
                    })
                    this.loading = false
                    return;
                    }
                
                    
                    this.loading = false


                } catch (err) {
                    console.log(err);
                }
            
        },

        go_back(){
            this.$router.push('/home')
        },
        go_back1(){
            this.isShowUserSubscription= false
        },
        
    }
  }
  </script>
    <style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&family=Sora:wght@500;600;700&display=swap');

    .container-fluid {
        --brand-900: #0f2e22;
        --brand-700: #24562b;
        --brand-500: #2f8f57;
        --text-900: #15211c;
        --text-700: #42524b;
        --line-200: #dce7e0;
        --line-300: #c4d5cb;
        --surface: #ffffff;
        --surface-soft: #f4f8f5;

        position: relative;
        min-height: 100vh;
        padding: 24px 32px 28px 14rem;
        border-radius: 16px;
        background: #cccccc41;
        overflow: hidden;
    }

    .container-fluid::after {
        content: '';
        position: absolute;
        inset: 0;
        pointer-events: none;
        background: repeating-linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.04) 0,
            rgba(255, 255, 255, 0.04) 8px,
            transparent 8px,
            transparent 16px
        );
    }

    .welcome {
        margin: 0;
        font-family: Manrope, sans-serif;
    }

    .dashboard-page {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: center;
        padding: 0.4rem;
        font-family: Manrope, sans-serif;
        color: var(--text-900);
    }

    .dashboard-inner-new {
        display: flex;
        flex-direction: column;
        gap: 14px;
        width: 100%;
        padding: 26px;
        border-radius: 22px;
        border: 1px solid rgba(255, 255, 255, 0.75);
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 249, 0.96));
        box-shadow:
            0 18px 45px rgba(15, 46, 34, 0.12),
            inset 0 1px 0 rgba(255, 255, 255, 0.75);
        animation: cardEnter 320ms ease-out;
    }

    .back-button {
        width: fit-content;
        min-width: 86px;
        height: auto;
        padding: 6px 16px;
        border-radius: 999px;
        border: 1px solid var(--line-300);
        background: rgba(255, 255, 255, 0.78);
        color: var(--text-700);
        font-family: Sora, sans-serif;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.02em;
        transition: all 200ms ease;
    }

    .back-button:hover {
        color: var(--brand-900);
        border-color: var(--brand-500);
        box-shadow: 0 8px 18px rgba(36, 86, 43, 0.14);
        transform: translateY(-1px);
    }

    .panel-title {
        min-height: 4px;
    }

    .airtime-data {
        display: flex;
        align-items: center;
    }

    .airtime1 {
        width: 100%;
        min-height: 52px;
        border: 0;
        border-radius: 14px;
        background: linear-gradient(135deg, var(--brand-900), var(--brand-700));
        color: #effaf3;
        font-family: Sora, sans-serif;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.01em;
        box-shadow: 0 14px 28px rgba(19, 58, 37, 0.25);
        pointer-events: none;
    }

    .mobile-operator,
    .payment-method {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .payment-label {
        font-family: Manrope, sans-serif;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #4d6359;
    }

    .payment-input {
        width: 100%;
        min-height: 50px;
        padding: 12px 14px;
        border: 1px solid var(--line-200);
        border-radius: 12px;
        background: var(--surface-soft);
        color: var(--text-900);
        font-family: Manrope, sans-serif;
        font-size: 14px;
        font-weight: 600;
        outline: none;
        transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
    }

    .payment-input:focus {
        border-color: var(--brand-500);
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(47, 143, 87, 0.12);
    }

    .a-text {
        color: var(--text-900) !important;
        font-weight: 700 !important;
        background: #f3f7f4;
    }

    .operator-icons {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 10px;
    }

    .op-icons {
        min-height: 62px;
        padding: 8px 10px;
        border-radius: 14px;
        border: 1px solid var(--line-200);
        background: var(--surface);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
    }

    .op-icons:hover {
        border-color: var(--brand-500);
        box-shadow: 0 10px 20px rgba(19, 58, 37, 0.1);
        transform: translateY(-1px);
    }

    .op-icons img {
        max-height: 30px;
        width: auto;
    }

    .op-icons.selected {
        border-color: var(--brand-700);
        box-shadow: 0 0 0 2px rgba(36, 86, 43, 0.15);
        background: linear-gradient(180deg, #f8fefb, #eef8f2);
    }

    .btn-panel {
        display: flex;
        flex-direction: column;
        gap: 10px;
        margin-top: 6px;
    }

    .btn-continue,
    .btn-cancel,
    .btn-primary {
        width: 100%;
        min-height: 50px;
        border-radius: 12px;
        font-family: Sora, sans-serif;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
    }

    .btn-continue,
    .btn-primary {
        border: 0;
        color: #f5fff9;
        background: linear-gradient(135deg, #184f32 0%, #2f8f57 100%);
        box-shadow: 0 12px 24px rgba(30, 93, 59, 0.28);
    }

    .btn-cancel {
        border: 1px solid var(--line-300);
        background: rgba(255, 255, 255, 0.84);
        color: #32463d;
    }

    .btn-continue:hover,
    .btn-primary:hover,
    .btn-cancel:hover {
        transform: translateY(-1px);
        filter: saturate(1.05);
    }

    .btn-cancel:hover {
        box-shadow: 0 8px 18px rgba(21, 33, 28, 0.08);
    }

    .vcard-modal-mask {
        position: fixed;
        inset: 0;
        z-index: 1000;
        background: rgba(7, 20, 14, 0.56);
        backdrop-filter: blur(4px);
    }

    .vcard-modal-mask > div {
        width: min(440px, 92vw);
        margin: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 18px;
        background: #ffffff;
        border: 1px solid #e4eee7;
        box-shadow: 0 24px 50px rgba(0, 0, 0, 0.25);
        box-sizing: border-box;
        animation: modalPop 220ms ease;
        font-family: Manrope, sans-serif;
    }

    .vcard-modal-mask h3 {
        margin-top: 10px;
        font-size: 19px;
        color: var(--text-900);
        font-weight: 700;
        font-family: Sora, sans-serif;
    }

    .inputs1 {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 10px;
        width: 100%;
        margin-top: 12px;
    }

    .inputs1 .inputs-field1 {
        height: 46px;
        border-radius: 10px;
        border: 1px solid var(--line-300);
        font-size: 17px;
        font-weight: 700;
        font-family: Sora, sans-serif;
        text-align: center;
    }

    .inputs1 .inputs-field1:focus {
        border-color: var(--brand-500);
        box-shadow: 0 0 0 3px rgba(47, 143, 87, 0.14);
        outline: none;
    }

    :deep(.v-field) {
        border-radius: 12px !important;
        border: 1px solid var(--line-200) !important;
        background: var(--surface-soft) !important;
        box-shadow: none !important;
    }

    :deep(.v-field--focused) {
        border-color: var(--brand-500) !important;
        box-shadow: 0 0 0 3px rgba(47, 143, 87, 0.12) !important;
        background: #fff !important;
    }

    :deep(.v-label) {
        font-family: Manrope, sans-serif !important;
        color: #557165 !important;
        font-size: 13px !important;
    }

    .error {
        color: #fff;
        font-size: 10px;
    }

    .copy-refid1 {
        cursor: pointer;
    }

    @keyframes cardEnter {
        from {
            opacity: 0;
            transform: translateY(8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes modalPop {
        from {
            opacity: 0;
            transform: translate(-50%, -48%);
        }
        to {
            opacity: 1;
            transform: translate(-50%, -50%);
        }
    }

    @media screen and (max-width: 1024px) {
        .container-fluid {
            padding: 18px 14px 24px;
            border-radius: 0;
        }
    }

    @media screen and (max-width: 768px) {
        .dashboard-page {
            padding: 0;
        }

        .dashboard-inner-new {
            padding: 16px;
            border-radius: 16px;
            gap: 12px;
        }

        .airtime1 {
            min-height: 46px;
            font-size: 13px;
        }

        .operator-icons {
            grid-template-columns: 1fr;
        }

        .btn-continue,
        .btn-cancel,
        .btn-primary {
            min-height: 46px;
            font-size: 12px;
        }

        .inputs1 {
            gap: 8px;
        }

        .inputs1 .inputs-field1 {
            height: 42px;
            font-size: 15px;
        }
    }
    </style>
